import type { TenantConfig } from "./types";

// Fallback tenant used when VITE_TENANT / config.json doesn't name
// one. Generic Nova-OS-School branding, English-first, all three
// shipped subjects, no role hides.
export const defaultTenant: TenantConfig = {
  slug: "default",
  displayName: "Nova OS School",
  tagline: "School AI Portal",
  defaultLocale: "en",
  subjects: [
    { agentId: "chemistry-assistant", labelKey: "chat.subjects.chemistry" },
    { agentId: "math-assistant", labelKey: "chat.subjects.math" },
    { agentId: "english-assistant", labelKey: "chat.subjects.english" },
  ],
  brand: {
    logoSrc: "/brand/favicon.svg",
  },
};
